import { cn } from '~/utils/cn';

import { PLATFORM_LOGO } from './platform-logo';

interface ChannelChipProps {
  /** Connector platform name — drives the brand glyph (Google, Meta, …). */
  platform: string;
  /** Display text shown next to the glyph (e.g. "Google Merchant Center"). */
  label: string;
  className?: string;
  darkBg?: boolean;
  /** `data-testid` for the chip (default `channel-chip`). */
  testId?: string;
}

/** Icon + text chip used to surface a connector channel. Width is intrinsic
 *  to the label per the design spec — the height/padding/radius match Figma. */
export function ChannelChip({
  platform,
  label,
  className,
  darkBg = false,
  testId = 'channel-chip',
}: ChannelChipProps) {
  const logo = PLATFORM_LOGO[platform];
  return (
    <span
      data-testid={testId}
      className={cn(
        darkBg ? 'bg-surface-date-pill' : 'bg-surface-subtle',
        'inline-flex h-9 items-center gap-2 rounded-lg px-4 py-1.5 text-sm font-medium text-neutral-100',
        className,
      )}
    >
      {logo && <img src={logo} alt="" className="h-5 w-5 shrink-0 object-contain" />}
      {label}
    </span>
  );
}
